export const fmt = (ts) => {
  const d = new Date(ts * 1000);
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0") +
    " " +
    String(d.getHours()).padStart(2, "0") +
    ":" +
    String(d.getMinutes()).padStart(2, "0")
  );
};

export function calculatePrecision(candles) {
  if (!candles.length) return 2;
  const avg = candles.reduce((s, c) => s + c.close, 0) / candles.length;
  if (avg < 0.00001) return 8;
  if (avg < 0.001) return 6;
  if (avg < 1) return 4;
  if (avg < 100) return 3;
  return 2;
}

export function buildOrderMarkers(candles, markers = []) {
  if (!candles.length || !markers.length) return [];
  const precision = calculatePrecision(candles);
  const lastTime = candles[candles.length - 1].time;

  return markers.map((m) => ({
    time: m.unixTime || lastTime,
    price: Number(m.price),
    type: m.type,
    label: `${m.label} @ ${Number(m.price).toFixed(precision)}`,
  }));
}
